import type { Field, Row } from "./types";
import { sigla } from "./config";

const brl = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
});

const num = new Intl.NumberFormat("pt-BR", { maximumFractionDigits: 2 });

export function formatCurrency(value: unknown): string {
  if (value === null || value === undefined || value === "") return "—";
  const n = Number(value);
  return Number.isNaN(n) ? "—" : brl.format(n);
}

export function formatDate(value: unknown): string {
  if (!value) return "—";
  const d = new Date(value as string);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleDateString("pt-BR", { timeZone: "UTC" });
}

/** Lê um campo de LISTA (JSONB) que pode chegar como array ou como texto JSON. */
export function lerLista(value: unknown): string[] {
  if (Array.isArray(value)) return value.map(String);
  if (typeof value === "string" && value.trim().startsWith("[")) {
    try {
      const p = JSON.parse(value);
      if (Array.isArray(p)) return p.map(String);
    } catch {
      /* texto que não é lista — cai fora */
    }
  }
  return [];
}

/** Formata o valor de uma célula conforme o tipo do campo. */
export function formatCell(field: Field, row: Row): string {
  const value = row[field.name];

  /*
   * Checklist (ex.: tipo de análise) mostra os RÓTULOS, não as chaves internas:
   * "FQ · CR" e não "fisicoQuimica,agdGases". E lista vazia não é "—": no
   * laudo, não escolher nada significa TODAS as seções — dizer "—" faria
   * parecer que a análise chegou sem tipo.
   */
  if (field.type === "checklist") {
    const chaves = lerLista(value);
    if (chaves.length === 0) return "todas";
    // A sigla vem da tabela de nomes (src/config.ts), não recortada do rótulo:
    // recortar por "·" quebrava silenciosamente quando o rótulo mudava.
    return chaves.map((c) => sigla(c)).join(" · ");
  }

  if (value === null || value === undefined || value === "") return "—";
  switch (field.type) {
    case "currency":
      return formatCurrency(value);
    case "date":
      return formatDate(value);
    case "number":
      return num.format(Number(value));
    case "password":
      return "••••••";
    default:
      return String(value);
  }
}

/** Classe de cor (pílula) para um valor de status, conforme o texto. */
export function statusTone(value: string): string {
  const v = value.toLowerCase();
  // "Saída" (movimentação) em vermelho; "Entrada" cai na regra "ok" (verde) abaixo.
  if (["zerado", "divergente", "inativo", "cancelad", "urgente", "atrasad", "vencid", "crític", "falta", "reprovad", "descarte", "saída", "saida"].some((s) => v.includes(s)))
    return "danger";
  if (["abaixo", "parado", "obsolet", "pendente", "em separação", "separação", "alta", "andamento", "aguardando", "a receber", "ajuste", "ressalva"].some((s) => v.includes(s)))
    return "warn";
  if (["normal", "conforme", "ativo", "ativa", "concluíd", "concluid", "disponível", "recebid", "separado", "aprovad", "entrada", "compra"].some((s) => v.includes(s)))
    return "ok";
  return "neutral";
}
